import React from "react";
import successCoupon from "../../../../../assets/images/couponsuccess.png";
import Header from "../../../../Layout/Header";
const DiscountOrderSuccess = () => {
  return (
    <div className="">
      <Header name={"العروض والكوبونات"} />
      <div className="flex justify-center lg:mt-[72px] ">
        <img src={successCoupon} alt="" />
      </div>
      <h1 className="text-[32px] text-center font-extrabold  mt-[70px] lg:mb-[180px]">
        تم ارسال العرض الى بريدك الإلكتروني بنجاح
      </h1>
    </div>
  );
};

export default DiscountOrderSuccess;
